import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconMergeRequest: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        d="M6.9375 16.75H3.875C3.53038 16.75 3.25 16.4696 3.25 16.125V13.1562C3.25 12.8112 2.97019 12.5312 2.625 12.5312C2.27981 12.5312 2 12.8112 2 13.1562V16.125C2 17.1589 2.84113 18 3.875 18H6.9375C7.28269 18 7.5625 17.7202 7.5625 17.375C7.5625 17.0298 7.28269 16.75 6.9375 16.75Z"
        fill={fill}
      />
      <path
        d="M6.59684 6.77546C6.35203 6.53214 5.95628 6.53333 5.71297 6.77814C5.46963 7.02296 5.47084 7.41871 5.71566 7.66202L7.4705 9.40624H2.625C2.27981 9.40624 2 9.68605 2 10.0312C2 10.3764 2.27981 10.6562 2.625 10.6562H7.42209L5.71347 12.3714C5.46984 12.6159 5.47063 13.0117 5.71516 13.2553C5.83713 13.3768 5.99669 13.4375 6.15625 13.4375C6.31659 13.4375 6.47694 13.3762 6.59903 13.2536L8.51331 11.332C8.86747 10.9778 9.0625 10.507 9.0625 10.0061C9.0625 9.50534 8.86747 9.03446 8.51197 8.67899L6.59684 6.77546Z"
        fill={fill}
      />
      <path
        d="M2.625 7.5C2.97019 7.5 3.25 7.22019 3.25 6.875V3.875C3.25 3.53038 3.53038 3.25 3.875 3.25H6.9375C7.28269 3.25 7.5625 2.97019 7.5625 2.625C7.5625 2.27981 7.28269 2 6.9375 2H3.875C2.84113 2 2 2.84113 2 3.875V6.875C2 7.22019 2.27981 7.5 2.625 7.5Z"
        fill={fill}
      />
      <path
        d="M17.375 9.40625H12.5295L14.2843 7.66203C14.5292 7.41869 14.5304 7.02297 14.287 6.77816C14.0437 6.53334 13.648 6.53212 13.4032 6.77547L11.4867 8.68034C11.1325 9.0345 10.9375 9.50534 10.9375 10.0062C10.9375 10.507 11.1325 10.9778 11.4858 11.3312L13.401 13.2536C13.5231 13.3762 13.6834 13.4375 13.8438 13.4375C14.0033 13.4375 14.1629 13.3768 14.2848 13.2553C14.5294 13.0117 14.5302 12.6159 14.2865 12.3714L12.5779 10.6562H17.375C17.7202 10.6562 18 10.3764 18 10.0312C18 9.68606 17.7202 9.40625 17.375 9.40625Z"
        fill={fill}
      />
      <path
        d="M16.125 2H13.0625C12.7173 2 12.4375 2.27981 12.4375 2.625C12.4375 2.97019 12.7173 3.25 13.0625 3.25H16.125C16.4696 3.25 16.75 3.53038 16.75 3.875V6.875C16.75 7.22019 17.0298 7.5 17.375 7.5C17.7202 7.5 18 7.22019 18 6.875V3.875C18 2.84113 17.1589 2 16.125 2Z"
        fill={fill}
      />
      <path
        d="M17.375 12.5312C17.0298 12.5312 16.75 12.8112 16.75 13.1562V16.125C16.75 16.4696 16.4696 16.75 16.125 16.75H13.0625C12.7173 16.75 12.4375 17.0298 12.4375 17.375C12.4375 17.7202 12.7173 18 13.0625 18H16.125C17.1589 18 18 17.1589 18 16.125V13.1562C18 12.8112 17.7202 12.5312 17.375 12.5312Z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconMergeRequest;
